import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { Container, Page } from '@ui';
import { AI_TOOLS } from '@constants';
import { GenericQuery } from '@features/query/GenericQuery';
import { ROUTES } from '@constants/routes';
import { useNavigate } from 'react-router';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { AdvancedSettingsButton } from '@containers/DigitalAnalyst/AdvancedSettings';
import { Body1 } from '@ui';
import { AnswerConfigContext } from '@/contexts/AnswerConfigContext';
import { QueryControllerProvider } from '@/contexts/QueryControllerContext';
import { AdvancedSettingsProvider } from '@/contexts/AdvancedSettingsContext';
import { ModeContext } from '@/contexts/ModeContext';
import { INPUT_KEYS } from '@constants';
import { DOCUMENT_SELECTION_MODES } from '@features/document/DocumentSelectionModal/modes';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
`;

function Heading() {
  return (
    <HeadingWrapper>
      <Body1 bold>Digital Analyst</Body1>
    </HeadingWrapper>
  );
}

const tool = AI_TOOLS.REASONING_QUERY;

const answerConfig = {
  enableMoreDetail: false,
  enableLinks: true,
  ignoreLatex: false,
  enableRating: false,
  enableShare: false,
};
const modeContext = {
  tool,
  isReasoningQuery: true,
  autoSelectDefaultDocuments: true,
  enableFollowUpQuestions: false,
  enableSearchForMoreDetail: false,
  enableCitations: false,
  autoSelectRecentDocuments: false,
  documentSelectionModes: [DOCUMENT_SELECTION_MODES.myDocs],
  defaultActiveDocumentSelectionMode: DOCUMENT_SELECTION_MODES.myDocs,
  inputs: {
    [INPUT_KEYS.question]: true,
    [INPUT_KEYS.sources]: true,
  },
  promptSuffix:
    'When answering the question, only answer in JSON in the following format: { "reasoning": "reasoning", "answer": "answer" }',
};

export function ReasoningQuery() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page>
          <BackArrowButton onClick={onGoBack} />
          <AdvancedSettingsButton tool={tool} />

          <Container top={40}>
            <ModeContext.Provider value={modeContext}>
              <AdvancedSettingsProvider>
                <QueryControllerProvider>
                  <AnswerConfigContext.Provider value={answerConfig}>
                    <GenericQuery heading={<Heading />} />
                  </AnswerConfigContext.Provider>
                </QueryControllerProvider>
              </AdvancedSettingsProvider>
            </ModeContext.Provider>
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}
